import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "parent",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M17.71 5.04006C18.1 4.65006 18.1 4.00006 17.71 3.63006L15.37 1.29006C15 0.900059 14.35 0.900059 13.96 1.29006L12.831 2.41296C12.4386 2.80317 12.4378 3.43782 12.829 3.82909L15.1648 6.16488C15.5546 6.55465 16.1863 6.55551 16.5771 6.1668L17.71 5.04006ZM0.292574 14.9572C0.105233 15.1447 0 15.3989 0 15.664V18.0001C0 18.5523 0.447715 19.0001 1 19.0001H3.33552C3.60089 19.0001 3.85539 18.8946 4.04295 18.7068L14.1035 8.63716C14.4938 8.24659 14.4936 7.61367 14.1032 7.22327L11.7674 4.88749C11.3768 4.49684 10.7434 4.49698 10.3529 4.8878L0.292574 14.9572Z",
		fill: "parent"
	})]
});
const ForwardRef = forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
